(function (factory) {
  'use strict';

  var core = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = core;
  }

  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  core.boot(window, document);
})(function () {
  'use strict';

  var RULES = Object.freeze([
    Object.freeze({ max: 7500, fee: 20, variantId: '46257071751354' }),
    Object.freeze({ max: 10000, fee: 25, variantId: '46257071784122' }),
    Object.freeze({ max: 20000, fee: 45, variantId: '46257071816890' }),
    Object.freeze({ max: 30000, fee: 65, variantId: '46257071849658' }),
    Object.freeze({ max: 40000, fee: 85, variantId: '46257071882426' }),
    Object.freeze({ max: 50000, fee: 100, variantId: '46257071915194' }),
    Object.freeze({ max: 75000, fee: 150, variantId: '46257071947962' })
  ]);

  function parseQuantity(value) {
    var normalized = String(value == null ? '' : value).replace(/,/g, '');
    var match = normalized.match(/\d+/);
    return match ? Number(match[0]) : 0;
  }

  function ruleForQuantity(quantity) {
    var numericQuantity = Number(quantity) || 0;

    if (!numericQuantity) {
      return RULES[0];
    }

    for (var index = 0; index < RULES.length; index += 1) {
      if (numericQuantity <= RULES[index].max) {
        return RULES[index];
      }
    }

    return null;
  }

  function formatFee(amount) {
    return '+$' + Number(amount).toFixed(2);
  }

  function deriveState(quantity, preferredSelection) {
    var rule = ruleForQuantity(quantity);
    var preferred = preferredSelection === 'priority' ? 'priority' : 'standard';

    if (!rule) {
      return {
        available: false,
        selection: 'standard',
        fee: null,
        feeText: 'Quote required',
        variantId: null,
        status: 'Priority Rush is available by custom quote for quantities of 100,000 or more.',
        description: 'Rush production requires a custom quote at this quantity.'
      };
    }

    return {
      available: true,
      selection: preferred,
      fee: rule.fee,
      feeText: formatFee(rule.fee),
      variantId: rule.variantId,
      status: preferred === 'priority'
        ? 'Priority Rush selected. The rush fee will be added with this label order.'
        : 'Priority Rush is available for the selected quantity.',
      description: 'Move this order ahead in the production queue.'
    };
  }

  function createGroupId(now, randomValue) {
    var timestamp = Number(now == null ? Date.now() : now).toString(36);
    var randomPart = String(randomValue == null ? Math.random() : randomValue)
      .replace(/^0\./, '')
      .replace(/[^a-z0-9]/gi, '')
      .slice(0, 10);

    if (!randomPart) {
      randomPart = 'rush';
    }

    return 'vp-rush-' + timestamp + '-' + randomPart;
  }

  function boot(windowObject, documentObject) {
    if (windowObject.__vpRollLabelRushBooted) {
      return;
    }

    windowObject.__vpRollLabelRushBooted = true;

    var FIELDSET_SELECTOR = '[data-vp-rush]';
    var syncFrame = 0;

    function getProductRoot(fieldset) {
      return fieldset.closest('.m6pr, .m6pr-compact') || fieldset.closest('.f8pr') || fieldset;
    }

    function getForm(fieldset) {
      var formId = fieldset.getAttribute('data-form-id');
      return (formId && documentObject.getElementById(formId)) || fieldset.closest('form');
    }

    function getStateRoot(fieldset) {
      return fieldset.closest('.m6pr, .m6pr-compact') || fieldset.parentElement || fieldset;
    }

    function getQuantity(fieldset) {
      var quantity = parseQuantity(fieldset.getAttribute('data-selected-quantity'));

      if (quantity) {
        return quantity;
      }

      var productRoot = getProductRoot(fieldset);
      var controls = productRoot.querySelectorAll('select[name^="options["], input[name^="options["]');

      for (var index = 0; index < controls.length; index += 1) {
        var control = controls[index];
        var name = String(control.name || '').toLowerCase();

        if (name.indexOf('quantity') === -1 && name.indexOf('qty') === -1) {
          continue;
        }

        if (control.tagName === 'SELECT') {
          return parseQuantity(control.value);
        }

        if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) {
          continue;
        }

        return parseQuantity(control.value);
      }

      return 0;
    }

    function getCurrentVariantId(fieldset) {
      var form = getForm(fieldset);
      var variantInput = form ? form.querySelector('input[name="id"]') : null;
      return String(
        (variantInput && variantInput.value) ||
        fieldset.getAttribute('data-main-variant') ||
        ''
      );
    }

    function setSelectedClass(label, selected) {
      if (!label) {
        return;
      }

      label.classList.toggle('is-selected', selected);
      label.setAttribute('aria-checked', selected ? 'true' : 'false');
    }

    function syncFieldset(fieldset, options) {
      if (!fieldset || !fieldset.matches(FIELDSET_SELECTOR)) {
        return null;
      }

      var config = options || {};
      var stateRoot = getStateRoot(fieldset);
      var standardRadio = fieldset.querySelector('[data-vp-turnaround][value="standard"]');
      var priorityRadio = fieldset.querySelector('[data-vp-turnaround][value="priority"]');
      var standardLabel = fieldset.querySelector('[data-vp-rush-option="standard"]');
      var priorityLabel = fieldset.querySelector('[data-vp-rush-option="priority"]');
      var rushPrice = fieldset.querySelector('[data-vp-rush-price]');
      var rushDescription = fieldset.querySelector('[data-vp-rush-description]');
      var rushStatus = fieldset.querySelector('[data-vp-rush-status]');
      var turnaroundProperty = fieldset.querySelector('[data-vp-rush-turnaround-property]');
      var rushGroupProperty = fieldset.querySelector('[data-vp-rush-group-property]');
      var addon = fieldset.querySelector('[data-vp-rush-addon]');

      if (
        !standardRadio ||
        !priorityRadio ||
        !standardLabel ||
        !priorityLabel ||
        !rushPrice ||
        !turnaroundProperty ||
        !rushGroupProperty ||
        !addon
      ) {
        return null;
      }

      var requestedSelection = config.selection || stateRoot.getAttribute('data-vp-rush-selection');

      if (!requestedSelection) {
        requestedSelection = priorityRadio.checked ? 'priority' : 'standard';
      }

      var quantity = getQuantity(fieldset);
      var state = deriveState(quantity, requestedSelection);

      if (!state.available) {
        stateRoot.setAttribute('data-vp-rush-selection', 'standard');
      } else {
        stateRoot.setAttribute('data-vp-rush-selection', state.selection);
      }

      standardRadio.checked = state.selection === 'standard';
      priorityRadio.checked = state.selection === 'priority' && state.available;
      priorityRadio.disabled = !state.available;

      setSelectedClass(standardLabel, standardRadio.checked);
      setSelectedClass(priorityLabel, priorityRadio.checked);

      priorityLabel.classList.toggle('is-disabled', !state.available);
      priorityLabel.setAttribute('aria-disabled', state.available ? 'false' : 'true');

      rushPrice.textContent = state.feeText;

      if (rushDescription) {
        rushDescription.textContent = state.description;
      }

      if (rushStatus) {
        rushStatus.textContent = state.status;
      }

      addon.checked = Boolean(state.available && state.selection === 'priority');
      addon.setAttribute('data-parent-product', getCurrentVariantId(fieldset));

      if (state.variantId) {
        addon.setAttribute('data-id', state.variantId);
      }

      if (state.selection === 'priority' && state.available) {
        turnaroundProperty.value = 'Priority Rush Production (' + state.feeText + ')';
        rushGroupProperty.disabled = false;

        if (config.createNewGroup || !rushGroupProperty.value) {
          rushGroupProperty.value = createGroupId();
        }
      } else {
        turnaroundProperty.value = 'Standard Production';
        rushGroupProperty.value = '';
        rushGroupProperty.disabled = true;
      }

      fieldset.setAttribute('data-vp-rush-ready', 'true');

      return state;
    }

    function syncAll(scope) {
      var root = scope && scope.querySelectorAll ? scope : documentObject;
      var fieldsets = [];

      if (root.matches && root.matches(FIELDSET_SELECTOR)) {
        fieldsets.push(root);
      }

      var nested = root.querySelectorAll ? root.querySelectorAll(FIELDSET_SELECTOR) : [];

      for (var index = 0; index < nested.length; index += 1) {
        fieldsets.push(nested[index]);
      }

      for (var fieldsetIndex = 0; fieldsetIndex < fieldsets.length; fieldsetIndex += 1) {
        syncFieldset(fieldsets[fieldsetIndex]);
      }
    }

    function scheduleSyncAll() {
      if (syncFrame) {
        return;
      }

      var schedule = windowObject.requestAnimationFrame || function (callback) {
        return windowObject.setTimeout(callback, 16);
      };

      syncFrame = schedule(function () {
        syncFrame = 0;
        syncAll(documentObject);
      });
    }

    documentObject.addEventListener('change', function (event) {
      var target = event.target;

      if (!target || !target.closest) {
        return;
      }

      var turnaroundInput = target.closest('[data-vp-turnaround]');

      if (turnaroundInput) {
        var fieldset = turnaroundInput.closest(FIELDSET_SELECTOR);
        var stateRoot = fieldset ? getStateRoot(fieldset) : null;

        if (fieldset && stateRoot) {
          var selection = turnaroundInput.value === 'priority' ? 'priority' : 'standard';
          stateRoot.setAttribute('data-vp-rush-selection', selection);
          syncFieldset(fieldset, { selection: selection });
        }

        return;
      }

      var optionControl = target.closest('select[name^="options["], input[name^="options["]');

      if (!optionControl) {
        return;
      }

      var optionName = String(optionControl.name || '').toLowerCase();

      if (optionName.indexOf('quantity') === -1 && optionName.indexOf('qty') === -1) {
        return;
      }

      var productRoot = optionControl.closest('.m6pr, .m6pr-compact, .f8pr');
      var fieldsetForOption = productRoot ? productRoot.querySelector(FIELDSET_SELECTOR) : null;

      if (fieldsetForOption) {
        fieldsetForOption.setAttribute('data-selected-quantity', optionControl.value);
        syncFieldset(fieldsetForOption);
      }
    }, true);

    documentObject.addEventListener('submit', function (event) {
      var form = event.target;

      if (!form || !form.querySelector) {
        return;
      }

      var fieldset = form.querySelector(FIELDSET_SELECTOR);

      if (fieldset) {
        syncFieldset(fieldset, { createNewGroup: true });
      }
    }, true);

    documentObject.addEventListener('formdata', function (event) {
      var form = event.target;
      var fieldset = form && form.querySelector ? form.querySelector(FIELDSET_SELECTOR) : null;

      if (fieldset) {
        syncFieldset(fieldset);
      }
    }, true);

    windowObject.addEventListener('productVariants', scheduleSyncAll);
    documentObject.addEventListener('shopify:section:load', scheduleSyncAll);

    if (documentObject.readyState === 'loading') {
      documentObject.addEventListener('DOMContentLoaded', function () {
        syncAll(documentObject);
      }, { once: true });
    } else {
      syncAll(documentObject);
    }

    if ('MutationObserver' in windowObject) {
      var contentRoot = documentObject.getElementById('content') || documentObject.body;

      if (contentRoot) {
        var observer = new windowObject.MutationObserver(function (records) {
          for (var recordIndex = 0; recordIndex < records.length; recordIndex += 1) {
            var addedNodes = records[recordIndex].addedNodes;

            for (var nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex += 1) {
              var node = addedNodes[nodeIndex];

              if (!node || node.nodeType !== 1) {
                continue;
              }

              if (
                (node.matches && node.matches(FIELDSET_SELECTOR)) ||
                (node.querySelector && node.querySelector(FIELDSET_SELECTOR))
              ) {
                scheduleSyncAll();
                return;
              }
            }
          }
        });

        observer.observe(contentRoot, {
          childList: true,
          subtree: true
        });
      }
    }

    windowObject.VaraPrintRollLabelRush = {
      syncAll: syncAll,
      syncFieldset: syncFieldset,
      rules: RULES.slice()
    };
  }

  return {
    RULES: RULES,
    parseQuantity: parseQuantity,
    ruleForQuantity: ruleForQuantity,
    formatFee: formatFee,
    deriveState: deriveState,
    createGroupId: createGroupId,
    boot: boot
  };
});
